/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState, useEffect } from "react";
import { get, patch, post } from "../../config/axios";
import Layout from "../../layout/Main/Layout";
import { Button, Typography } from "@mui/material";
import {
  coinPackColumn,
  coinPackFormFields,
} from "../../constants/coinPackPage";
import CustomTable from "../../components/Custom/Table/CustomTable";
import FormModal from "../../components/Custom/FormModal/FormModal";
import { postFiles } from "../../config/axios";
import { toastMessage } from "../../utils/toastMessage";
import { patchAPI, updateAPI } from "../../helper/apiCallHelper";
import AddIcon from "@mui/icons-material/Add";

const CoinPacks = () => {
  console.log("In coin packs");
  const [coinPacks, setCoinPacks] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [edit, setEdit] = useState(false);

  const [pagination, setPagination] = useState({
    totalData: 0,
    totalPage: 1,
    perPage: 10,
    currentPage: 1,
  });

  const fetchCoinsPack = async (page, limit) => {
    try {
      setLoading(true);

      // Make API request with pagination query parameters
      const res = await get(
        `/api/dashboard/features/coin-packs?page=${page}&limit=${limit}`
      );

      console.log("response", res);

      setCoinPacks(
        res?.data.map((item) => ({
          ...item,
          action: { edit: true, delete: false },
        }))
      );

      // Store pagination metadata
      setPagination({
        totalData: res?.totalData,
        totalPage: res?.totalPage,
        perPage: limit,
        currentPage: page,
      });

      setLoading(false);
    } catch (err) {
      console.error("Error:", err);
      setLoading(false);
    }
  };
  const handleChange = (newPage) => {
    setPagination((prev) => ({
      ...prev,
      currentPage: newPage,
    }));

    fetchCoinsPack(newPage, pagination.perPage);
  };

  const handleSubmit = async (formData, isEditing) => {
    console.log("formData is:", formData._id);
    try {
      if (isEditing) {
        setEdit(true);
        console.log("formData", formData);
        let formDataWithNumberCoins;
        if (typeof formData?.image === "object") {
          let form = new FormData();
          form.append("file", formData?.image);
          const res2 = await postFiles("/api/app/user/uploadImage", form);

          formDataWithNumberCoins = {
            ...formData,
            coins: Number(formData.coins),
            image: res2.data.url,
          };
        } else {
          formDataWithNumberCoins = {
            ...formData,
            coins: Number(formData.coins),
          };
        }
        const res = await patch(
          `/api/dashboard/features/edit-coin-pack/${formData?._id}`,
          formDataWithNumberCoins
        );
        setMessage("Edited Successfully");
        setIsModalOpen(false);
        setEdit(false);
      } else {
        let form = new FormData();
        form.append("file", formData?.image);
        const res2 = await postFiles("/api/app/user/uploadImage", form);
        // need to implment Edit for coin pack here (call this api)
        const formDataWithNumberCoins = {
          ...formData,
          coins: Number(formData.coins),
          image: res2.data.url,
        };
        console.log("Converted formData is:", formDataWithNumberCoins);
        const res = await post(
          "/api/dashboard/features/create-coin-pack",
          formDataWithNumberCoins
        );
        setMessage("Added Successfully");
        setIsModalOpen(false);
        setEditData({});
      }
    } catch (err) {
      console.log("err", err);
      setLoading(true);
    }
  };
  useEffect(() => {
    fetchCoinsPack(pagination.currentPage, pagination.perPage);
  }, [message, isModalOpen, edit, pagination.currentPage]);
  console.log("totalPage", pagination.totalPage);

  const openModal = (type, dataForEdit) => {
    if (type === "edit") {
      setEditModal(true);
      setEditData(dataForEdit);
    } else {
      setIsModalOpen(true);
    }
  };
  const closeModal = (type) => {
    if (type === "edit") {
      setEditModal(false);
      setEditData({});
    } else {
      setIsModalOpen(false);
      setEditData({});
    }
  };

  const handleActive = async (id, active, type) => {
    setLoading(true);
    let updateValue = {};
    if (type === "published") {
      updateValue = {
        isPublished: active,
      };
    }
    if (type === "active") {
      updateValue = {
        active: active,
      };
    }
    let response = await patchAPI(
      `/api/dashboard/features/edit-coin-pack/${id}`,
      updateValue
    );
    // let response = await put(`/api/dashboard/features/updateEvent?id=${id}`, {
    //   active: active,
    // });
    setLoading(false);
    setMessage(response.message);
    toastMessage(response, "success");
  };

  console.log("editData", editData);

  return (
    <>
      <Layout>
        <div className="flex justify-between p-2">
          <Typography variant="h5">Coin Packs</Typography>
          <Button
            variant="outlined"
            startIcon={<AddIcon fontSize="large" />}
            style={{ fontWeight: "bold" }}
            onClick={() => openModal()}
          >
            Add Coins Pack
          </Button>
        </div>
        <CustomTable
          data={coinPacks}
          columns={coinPackColumn}
          handleEdit={(row) => openModal("edit", row)}
          handleDelete={() => {}}
          handleStatus={() => {}}
          handleActive={(row, active, type) => {
            handleActive(row, active, type);
          }}
          handlePageChange={handleChange}
          pageNumber={pagination.currentPage}
          pageCount={pagination.totalPage}
          loading={loading}
        />
      </Layout>
      <FormModal
        isOpen={isModalOpen || editModal}
        onClose={() => closeModal(editModal ? "edit" : "add")}
        onSubmit={handleSubmit}
        fields={coinPackFormFields}
        header={editModal ? "Edit Coin Pack" : "Add Coin Pack"}
        initialData={editData}
        isEditing={editModal}
      />
    </>
  );
};
export default CoinPacks;
